import React from 'react';
import {observer} from 'mobx-react';
import Subnav from 'main/containers/benefits/components/Subnav';
import {BenefitInfoContainer} from 'main/components/benefits';
import {auth} from 'main/tools';
import {Layout} from 'shared/components';

const MyEnrolmentInfo = observer(({scope}) => {
  return (
    <div>
      <Subnav scope={scope}/>
      <Layout>
        <BenefitInfoContainer employeeId={auth.employee.id}/>
      </Layout>
    </div>
  );
});

export default MyEnrolmentInfo;
